/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import { Checkbox } from '@progress/kendo-react-inputs';
import * as API from '../../framework/API/api'
import { BA_ACTION, CONTENT_CUSTOM_ENUM, ENTITYNAME, LOCALSTORAGE_KEY, MEDIA_TRANSMISSION, MEDIACATEGORIES, TOAST_TYPES } from '../../framework/constant/constant';
import { TimePickerWithFormat } from '../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';
import { utility } from '../../framework/utility/utilityProvider';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import { useTranslation } from '../../locale/useTranslation';
import SaveButton from '../../framework/forms/helpercomponents/buttons/SaveButton';
import CancelButton from '../../framework/forms/helpercomponents/buttons/CancelButton';
import InfoRoundButton from '../../components/InfoRoundButton';
import { ContentEditForm } from '../masters/ContentEditForm';
import { GenreEditForm } from '../masters/GenreEditForm';
import LanguageTranslator from '../../components/LanguageTranslator';
import IMDBEditForm from './IMDBEditForm';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { TimeCell } from '../../framework/forms/helpercomponents/CustomGridCells/TimeCell';
import { ArrayCell } from '../../framework/forms/helpercomponents/CustomGridCells/ArrayCell';
import { Loader } from '../../framework/forms/helpercomponents/Loader';
import { DataHelper } from '../../framework/helper/DataHelper';
import { useNavigate } from 'react-router-dom';
import MMImageEditForm from './MMImageEditForm';
import ImageCard from './component/ImageCard';
import MediaHeroCard from './component/MediaHeroCard';
import BossDialog from '../../components/BossDialog';
import BossAssistantIcon from './component/BossAssistantIcon';
import MediaEpisodeSettingForm from './MediaEpisodeSettingForm';
import MyMultiSelect from '../../components/MyMultiSelect';
import moment from 'moment';
import ToastNotification from '../../components/ToastNotification';

export const MediaEpisodeDetailForm = ({ dataItem = {}, setDataItem, IMDbData, setIMDbData, selectedMusicCategory, setSelectedMusicCategory, setMediaEpisodeMetaData, ...props }) => {

  const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
  const isEtisalat = company && company.Name && company.Name.toLowerCase() == "etisalat";

  const [content, setContent] = useState([]);
  const [mediaCategory, setMediaCategory] = useState([]);
  const [mediaCategoryType, setMediaCategoryType] = useState([]);
  const [genre, setGenre] = useState([]);
  const [moduleName, setModuleName] = useState('');
  const [openImageBank, setOpenImageBank] = useState(false);
  const [openImageInput, setOpenImageInput] = useState(false);
  const [openImageBrowse, setOpenImageBrowse] = useState(false);
  const [openMediaEpisodeSettingForm, setOpenMediaEpisodeSettingForm] = useState(false);


  const [showTranslateForm, setShowTranslateForm] = useState(false);
  const defaultFormState = {
    Content: false,
    Genre: false
  }
  const [showEditForm, setShowEditForm] = useState(defaultFormState);
  const [selectedImageUrl, setSelectedImageUrl] = useState(dataItem.ImageUrl ?? 'https://i.postimg.cc/j5PsF5jZ/defaultmovie.png');
  //on create new entity and edit quickEdit is false but on quickEdit click quickEdit is true

  const [openForm, setFormOpen] = useState((dataItem.SID == 0 && !props?.isFromAddProgram) || props.quickEdit || props?.isManageContent);
  const [showEpisodeOverview, setShowEpisodeOverview] = useState(dataItem.SID == 0 ? true : false);
  const selectedMediaCategorySID = props.mediaCategory;
  const [showIMDbForm, setShowIMDbForm] = useState(false);
  const [openMusicCategory, setOpenMusicCategory] = useState(false);
  const [showAvailableMusic, setShowAvailableMusic] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [musicData, setMusicData] = useState([]);
  const [currentUserChannels, setCurrentUserChannels] = useState([]);
  const [durationString, setDurationString] = useState('00:00:00:00');
  const [transmissions, setTransmissions] = useState([]);
  // const [targetGroups, setTargetGroups] = useState([]);
  const [providers, setProviders] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [countries, setCountries] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [channels, setChannels] = useState([]);
  const [selectAllChannels, setSelectAllChannels] = useState(false);
  const [pgRatings, setPgRatings] = useState([]);
  const [selectAllPlatforms, setSelectAllPlatforms] = useState(false);

  useEffect(() => {
    setShowEpisodeOverview(dataItem.SID == 0 ? true : false);
  }, [dataItem.SID]);


  const navigate = useNavigate();
  const lang = useTranslation();

  useEffect(() => {
    loadCombo();
  }, []);

  useEffect(() => {
    setDurationString(typeof dataItem.Duration == 'string' ? dataItem.Duration : utility.convertMilisecondsToStringWithFrames(dataItem.Duration) ?? '00:00:00:00');
    setSelectedImageUrl(dataItem.ImageUrl ?? 'https://i.postimg.cc/j5PsF5jZ/defaultmovie.png');
  }, [dataItem]);

  const loadCombo = async (reset = true) => {

    let content = await API.getDataLookup(ENTITYNAME.Content, { sort: { Description: 1 }, query: ['Archive', '=', false] });
    let filteredContent = content.data.filter((item) =>
      item.MediaCategoryType.MediaCategorySID == props.mediaCategory || item.MediaCategoryType.MediaCategorySID == 0
    );
    setContent(filteredContent ?? []);

    let mediaCategory = await API.getDataLookup(ENTITYNAME.MediaCategory, { sort: { Description: 1 } });
    setMediaCategory(mediaCategory.data);
    setModuleName(mediaCategory.data.find((item) => item.SID == props.mediaCategory).Description);

    let mediaCategoryType = await API.getDataLookup(ENTITYNAME.MediaCategoryType, { sort: { Description: 1 } });
    setMediaCategoryType(mediaCategoryType.data);

    let genres = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
    setGenre(genres.data);

    let providerRes = await API.getDataLookup(ENTITYNAME.OttProvider, { sort: { Description: 1 } });
    setProviders(providerRes.data);

    let languagesRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
    setLanguages(languagesRes.data);

    let pgRatingRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
    setPgRatings(pgRatingRes.data);

    let userChannels = await utility.getUserChannels()
    setCurrentUserChannels(userChannels);

    let transmissionRes = Object.keys(MEDIA_TRANSMISSION).map((x) => ({
      _id: MEDIA_TRANSMISSION[x],
      Description: x
    }));
    setTransmissions(transmissionRes)

    // let targetGroupRes = await API.getDataLookup(ENTITYNAME.TargetGroups, { sort: { Name: 1 } });
    // setTargetGroups(targetGroupRes.data);

    const countryRes = await API.getDataLookup(ENTITYNAME.CountryCode, { sort: { Description: 1 } });
    setCountries(countryRes.data);

    if (props?.isFromAddProgram) {
      setDataItem({
        ...dataItem,
        MediaCategory: mediaCategory.data.find((obj) => obj.SID == selectedMediaCategorySID),
        MediaCategoryType: mediaCategoryType.data.find((obj) => obj.SID == props.mediaCategoryType),
      });
      return;
    }

    let platformRes = await API.getDataLookup(ENTITYNAME.Platform, { sort: { Description: 1 } });
    setPlatforms(platformRes.data);

    let channelRes = await API.getValidChannels(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
    setChannels(channelRes.data);

    if (dataItem.SID == 0 && filteredContent.length > 0 && reset) {

      let tempContent = filteredContent.length > 0 ? filteredContent.filter((obj) =>
        obj.MediaCategoryType.MediaCategorySID == props.mediaCategory)[0] ?? filteredContent[0] : {}
      setDataItem({
        ...dataItem,
        Genres: utility.getDefaultItems(genres.data),
        SubGenres: utility.getDefaultItems(genres.data),
        MediaType: dataItem?.MediaType?._id ? { _id: dataItem.MediaType._id, SID: dataItem.MediaType.SID, Description: dataItem.MediaType.Description } : {},
        MediaSubType: dataItem?.MediaSubType?._id ? { _id: dataItem.MediaSubType._id, SID: dataItem.MediaSubType.SID, Description: dataItem.MediaSubType.Description } : {},
        AssetId: await DataHelper.getNewAssetId(tempContent),
        Content: tempContent,
        MediaCategory: mediaCategory.data.find((obj) => obj.SID == selectedMediaCategorySID) ?? {},
        MediaCategoryType: mediaCategoryType.data.find((obj) => obj.SID == props.mediaCategoryType) ?? {},
        Channels: channelRes.data && channelRes.data.length == 1 ? channelRes.data : [],
      })
    }
  };

  const onChange = async (e) => {

    if (e.target.name == "DurationString") {
      setDurationString(e.target.value);

      setDataItem({
        ...dataItem,
        Duration: utility.convertStringWithFramesToMilliseconds(e.target.value)
      });

      return;
    }

    let updatedItem = { ...dataItem };

    if (e.target.name == "Content") {

      updatedItem.Content = e.target.value;

      const updatedContent = await API.getAndSaveNextNumber(
        e.target.value.SID,
        { ...e.target.value, isSaveNextnumber: false }
      );

      if (!updatedContent.success) return;

      updatedItem.AssetId = updatedContent.data.HouseNumber;

    } else if (e.target.name == "Title") {

      updatedItem.Title = e.target.value;
      dataItem?.SID == 0 && (updatedItem.Description = e.target.value);

    } else if (
      e.target.name == "CustomTitle1" ||
      e.target.name == "CustomTitle2"
    ) {

      let name = e.target.name == "CustomTitle1" ? "Title1" : "Title2";

      updatedItem.CustomTitle = {
        ...dataItem.CustomTitle,
        [name]: e.target.value
      };

    } else if (
      e.target.name == "CustomEpisodeTitle1" ||
      e.target.name == "CustomEpisodeTitle2"
    ) {

      let name =
        e.target.name == "CustomEpisodeTitle1"
          ? "Title1"
          : "Title2";

      updatedItem.CustomEpisodeTitle = {
        ...dataItem.CustomEpisodeTitle,
        [name]: e.target.value
      };

    } else if (
      e.target.name == "Foreground" ||
      e.target.name == "Background"
    ) {

      updatedItem.Colors = {
        ...dataItem.Colors,
        [e.target.name]: e.target.value
      };

    } else if (
      e.target.name == "ProductionYear" ||
      e.target.name == "Languages" ||
      e.target.name == "DubbedLanguages" ||
      e.target.name == "PGRating"
    ) {

      setMediaEpisodeMetaData &&
        setMediaEpisodeMetaData({
          ...props.metaData,
          [e.target.name]: e.target.value
        });

    } else if (e.target.name == "Country") {

      setMediaEpisodeMetaData &&
        setMediaEpisodeMetaData({
          ...props.metaData,
          Country: e.target.value
        });

    } else if (e.target.name === "isAllChannels") {

      const newValue = !selectAllChannels;

      setSelectAllChannels(newValue);

      updatedItem.Channels = newValue ? channels : [];

    } else if (e.target.name === "Channels") {

      updatedItem.Channels = e.target.value;

      if (e.target.value.length === channels.length) {
        setSelectAllChannels(true);
      } else {
        setSelectAllChannels(false);
      }

    } else if (e.target.name === "isAllPlatforms") {

      const newValue = !selectAllPlatforms;

      setSelectAllPlatforms(newValue);

      updatedItem.Platforms = newValue ? platforms : [];

    } else if (e.target.name === "Platforms") {

      updatedItem.Platforms = e.target.value;

      if (e.target.value.length === platforms.length) {
        setSelectAllPlatforms(true);
      } else {
        setSelectAllPlatforms(false);
      }

    } else {

      updatedItem[e.target.name] = e.target.value;

    }

    // update working title only for related fields
    if (["Title", "SeasonNumber", "EpisodeNumber", "PGRating", "DealReference"].includes(e.target.name)) {
      const pgRating = e.target.name === "PGRating" ? e.target.value?.Description : props.metaData?.PGRating?.Description;
      updatedItem.WorkingTitle = DataHelper.getWorkingTitle({
        title: updatedItem.Title,
        seasonNumber: updatedItem.SeasonNumber,
        episodeNumber: updatedItem.EpisodeNumber,
        pgRating: pgRating,
        dealReference: updatedItem.DealReference
      });
    }

    setDataItem(updatedItem);
  };

  const setSelectedImage = (dataList) => {
    setSelectedImageUrl(dataList[0].ImageUrl);
    setDataItem({ ...dataItem, ["ImageUrl"]: dataList[0].ImageUrl });
  }

  const isValidToSave = () => {

    if (dataItem.Title == undefined || dataItem.Title === "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_title_error_message });
      return false;
    }
    if (dataItem.SID == 0) {
      if (Object.keys(dataItem.Content).length === 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_content_error_message });
        return false;
      }
    }

    if (company && company?.segByRc) {
      if (dataItem.ReferenceCode == undefined || dataItem.ReferenceCode === "") {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_reference_code_error_message });
        return false;
      }
    }

    if (durationString == undefined || durationString.includes('_') || utility.convertStringWithFramesToMilliseconds(durationString) == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.duration_should_be_greater_than_zero_error_message });
      return false;
    }

    if (Object.keys(dataItem.Genres).length === 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_genres_media_episode_error_message });
      return false;
    }

    if (dataItem.Content.Custom == CONTENT_CUSTOM_ENUM.ETISALAT_TIT_Y_SN_EP_LNG && (props.metaData.Languages || []).length === 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_language_error_message });
      return false;
    }

    if (dataItem.Content.Custom == CONTENT_CUSTOM_ENUM.ECITY_LC_Y_TSN_CNC_PC_EP && (!dataItem?.MediaType || Object.keys(dataItem?.MediaType).length === 0)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_media_type_error_message });
      return false;
    }

    if (dataItem.Content.Custom == CONTENT_CUSTOM_ENUM.ECITY_LC_Y_TSN_CNC_PC_EP && (!props?.metaData?.Country || Object.keys(props?.metaData?.Country).length === 0)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_country_error_message });
      return false;
    }

    if (dataItem.Content.Custom == CONTENT_CUSTOM_ENUM.ETISALAT_TIT_Y_SN_EP_LNG && (props.metaData.ProductionYear == undefined || props.metaData.ProductionYear === "")) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_production_year_error_message });
      return false;
    }

    if (dataItem.IsMusic && Object.keys(selectedMusicCategory).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_music_category_error_message });
      return false;
    }

    if (dataItem.SID == 0) {
      if (!dataItem?.Channels || dataItem.Channels.length === 0) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_linear_channels_error_message });
        return false;
      }

      if (!dataItem?.isLinearUnlimitedRights) {
        if (!dataItem?.LinearStartDate || dataItem?.LinearStartDate == "") {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_linear_start_date_error_message });
          return false;
        }

        if (!dataItem?.LinearEndDate || dataItem?.LinearEndDate == "") {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_linear_end_date_error_message });
          return false;
        }

        if (dataItem.LinearStartDate > dataItem.LinearEndDate) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.linear_start_and_end_date_error_message });
          return false;
        }
      }

      if (!dataItem?.isNonLinearUnlimitedRights) {
        if (!dataItem?.NonLinearStartDate || dataItem?.NonLinearStartDate == "") {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_non_linear_start_date_error_message });
          return false;
        }

        if (!dataItem?.NonLinearEndDate || dataItem?.NonLinearEndDate == "") {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_non_linear_end_date_error_message });
          return false;
        }

        if (dataItem.NonLinearStartDate > dataItem.NonLinearEndDate) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.non_linear_start_and_end_date_error_message });
          return false;
        }
      }
    }
    return true;
  }

  const onCancelEdit = () => {
    if (dataItem.SID == 0) {
      navigate(-1);
    } else if (props?.isManageContent) {
      props.onCancelEdit();
    }
    else {
      if (props.onClose) {
        setFormOpen(false)
        props.onClose();

      } else {
        props.quickEdit ? navigate(-1) : setFormOpen(false);
      }
    }
  }

  //MANAGE CONTENT UPDATE PENDING
  const onSaveData = async () => {

    let isValid = isValidToSave();

    if (isValid) {

      if (props.quickEdit) {

        props.onSave();
        onCancelEdit();

      } else if (props?.isManageContent) {

        props.onSave();
        props.onCancelEdit();

      } else {

        setFormOpen(false);

      }
    }
  };

  const onCreateMasterClick = (key) => {
    setShowEditForm({
      ...defaultFormState,
      [key]: true
    });
  }

  const handleLangugaeTranslate = (data) => {
    setDataItem({ ...dataItem, Description: data });
    setShowTranslateForm(false);
  }

  const handleIMDbDataList = async (data) => {
    setIMDbData(data ?? {});
    let duration = data?.Runtime == "N/A" ? 0 : data?.Runtime?.split(" ")[0] * 60000;
    let genreList = data?.Genre?.split(",") ?? [];
    let genreDataList = [];
    for (let i = 0; i < genreList.length; i++) {
      let item = genreList[i];
      item = item.trim();
      let genreData = await API.getData(ENTITYNAME.Genre, { query: ['Description', '=', item] });
      if (genreData.data.length == 0) {
        let addNewGenre = await API.saveData(ENTITYNAME.Genre, { "Description": item, "Archive": false, "ExternalDescription": item, "AlternateDescription": item });
        genreDataList.push(addNewGenre.data);
      } else {
        genreDataList.push(genreData.data[0]);
      }
    };
    let prepareData = {
      Title: data?.Title,
      Description: data?.Plot,
      Duration: duration,
      ImageUrl: data?.Poster,
      Genres: genreDataList
    }
    setSelectedImageUrl(prepareData.ImageUrl);
    setDataItem({ ...dataItem, ...prepareData });

    var imdbMetaDataRes = await API.saveIMDbMetaData(null, data, false);
    if (imdbMetaDataRes.success) setMediaEpisodeMetaData(imdbMetaDataRes.data);

  }

  const handleMusicPreview = async () => {
    setShowAvailableMusic(true);
    //API CALL
    const musicRes = await API.getMusicByMusicCategory(selectedMusicCategory);
    if (musicRes.success) {
      setIsLoading(false)
      setMusicData(musicRes.data ?? []);
    }
  }

  const onBossAIMetaDataLoad = async (item) => {

    let aiDataRes = await utility.loadDataViaBOSS_AI(BA_ACTION.Thumbnail, item, dataItem);
    console.log(aiDataRes);
    return aiDataRes;

  }

  const setImageUrl = (data) => {
    if (data && data.success && data.imageUrl) {
      setSelectedImageUrl(data.imageUrl);
      setDataItem({ ...dataItem, ImageUrl: data.imageUrl });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: data.message });
    }
  }

  const style = {
    labelStyel: { fontSize: '11px', fontWeight: 600, color: '#444', marginBottom: '3px', display: 'block' }
  }

  return (
    <div className="mb-3 ml-2 mt-3" style={{ maxWidth: "100vw" }}>
      <MediaHeroCard
        imageUrl={dataItem?.ImageUrl}
        title={dataItem?.Title ? `${utility.subString(dataItem?.Title, 36)} ${selectedMediaCategorySID === MEDIACATEGORIES.Episode ? `EP-${dataItem?.EpisodeNumber}` : ""}` : `${lang.enter_title}`}
        assetId={dataItem?.AssetId}
        badges={[
          (dataItem?.Genres || []).map((obj) => obj?.Description).filter(Boolean).join(' | '),
          durationString,
        ].filter(Boolean)}
        summary={dataItem?.Description ? utility.subString(dataItem?.Description, 150) : ""}
        facts={[
          { label: lang.asset_id_label, value: `#${dataItem?.AssetId}` },
          { label: lang.episode_no_label ?? "Episode No", value: dataItem?.EpisodeNumber },
          { label: lang.genre_label, value: (dataItem?.Genres || []).map((obj) => obj?.Description).filter(Boolean).join(' | ') },
          { label: lang.duration_only_label ?? "Duration", value: durationString },
          { label: "Media Type", value: dataItem?.MediaType?.Description },
          { label: "Media SubType", value: dataItem?.MediaSubType?.Description },
          { label: lang.languages_label ?? "Languages", value: (dataItem?.Languages || []).map((obj) => obj?.Description).filter(Boolean).join(' | ') },
          { label: "Dubbed Languages", value: (dataItem?.DubbedLanguages || []).map((obj) => obj?.Description).filter(Boolean).join(' | ') },
          { label: lang.summary, value: dataItem?.Description ? utility.subString(dataItem?.Description, 150) : "" },
        ]}
        expanded={showEpisodeOverview}
        onToggleExpanded={() => setShowEpisodeOverview((prev) => !prev)}
        actions={[
          dataItem.SID > 0
            ? {
              title: "Settings",
              icon: "fa-solid fa-gear",
              onClick: () => setOpenMediaEpisodeSettingForm(true),
            }
            : null,
          {
            title: lang.edit_button_tooltip ?? "Edit",
            icon: "fa-solid fa-pen-to-square",
            onClick: () => setFormOpen(true),
          },
        ].filter(Boolean)}
      />
      {openForm &&
        <>
          <BossDialog
            title={dataItem.SID > 0 ? dataItem.Title : `${lang.create_dialog_header} ${moduleName}`}
            onClose={onCancelEdit}
            width={"75vw"}
            height={"auto"}
            style={{ maxHeight: '88vh' }}
          >
            {/* Action Buttons */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', paddingBottom: '10px', marginBottom: '14px', borderBottom: '1px solid #eaeaea' }}>
              <SaveButton title={lang.confirm_button} tooltip={lang.confirm_button_tooltip} onClick={() => onSaveData()} />
              <CancelButton onClick={onCancelEdit} />
            </div>

            <Form
              render={(formRenderProps) => (
                <FormElement>
                  <div style={{ display: 'flex', gap: '20px' }}>
                    {/* ── Left Panel: Form Fields ── */}
                    <div style={{ flex: 1, minWidth: 0 }}>

                      {/* ─── Section 1: Title & Description ─── */}
                      <div style={{ marginBottom: '16px', padding: '12px 14px', background: '#fafafa', borderRadius: '6px', border: '1px solid #f0f0f0' }}>
                        <div style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#3A3633', marginBottom: '10px', paddingLeft: '8px', borderLeft: '3px solid #3A3633' }}>
                          {lang.title_label} & {lang.description_label}
                        </div>

                        {/* Title Row */}
                        <div className="row" style={{ marginBottom: '8px' }}>
                          <div className="col-6">
                            <label style={style.labelStyel}>{lang.title_label} *
                              {selectedMediaCategorySID === MEDIACATEGORIES.Movie && (
                                <span className='cursor-pointer' style={{ backgroundColor: '#5a6268', color: 'white', padding: '1px 6px', borderRadius: '3px', fontSize: '9px', marginLeft: '8px', verticalAlign: 'middle' }} onClick={() => setShowIMDbForm(true)}>
                                  {lang.imdb_label}
                                </span>
                              )}
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              name="Title"
                              value={dataItem.Title}
                              onChange={(e) => onChange(e)}
                              required
                              style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }}
                            />
                          </div>

                          <div className="col-3">
                            <label style={style.labelStyel}>{company?.Name?.toLowerCase() == "rock" ? lang.chinese_title_label : lang.custom_title_1_label}</label>
                            <input name="CustomTitle1" type="text" className="form-control form-control-sm" value={dataItem?.CustomTitle?.Title1} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                          </div>
                          <div className="col-3">
                            <label style={style.labelStyel}>{company?.Name?.toLowerCase() == "rock" ? lang.spanish_title_label : lang.custom_title_2_label}</label>
                            <input name="CustomTitle2" type="text" className="form-control form-control-sm" value={dataItem?.CustomTitle?.Title2} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                          </div>
                        </div>

                        {/* Custom Titles Row */}
                        {selectedMediaCategorySID == MEDIACATEGORIES.Episode && <div className="row" style={{ marginBottom: '8px' }}>
                          <div className="col-1" style={{ paddingRight: "1px" }}>
                            <label style={style.labelStyel}>{lang.season_number_labelshort}</label>
                            <input
                              style={{ height: "30px", borderRadius: '4px', border: '1px solid #d0d0d0' }}
                              type="number"
                              className="form-control form-control-sm"
                              name="SeasonNumber"
                              value={dataItem.SeasonNumber}
                              onChange={(e) => onChange(e)}
                              min={1}
                              required
                            />
                          </div>
                          <div className="col-1" style={{ paddingRight: "1px" }}>
                            <label style={style.labelStyel}>{lang.episode_number_labelshort}</label>
                            <input
                              style={{ height: "30px", borderRadius: '4px', border: '1px solid #d0d0d0' }}
                              type="number"
                              className="form-control form-control-sm"
                              name="EpisodeNumber"
                              value={dataItem.EpisodeNumber}
                              onChange={(e) => onChange(e)}
                              min={1}
                              required
                            />
                          </div>
                          <div className="col-4">
                            <label style={style.labelStyel}>{lang.episode_title_label}</label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              name="EpisodeTitle"
                              value={dataItem.EpisodeTitle}
                              onChange={(e) => onChange(e)}
                              required
                              style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }}
                            />
                          </div>
                          <div className="col-3">
                            <label style={style.labelStyel}>{company?.Name?.toLowerCase() == "rock" ? lang.chinese_episode_title_label : lang.custom_episode_title_1_label}</label>
                            <input name="CustomEpisodeTitle1" type="text" className="form-control form-control-sm" value={dataItem?.CustomEpisodeTitle?.Title1} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                          </div>
                          <div className="col-3">
                            <label style={style.labelStyel}>{company?.Name?.toLowerCase() == "rock" ? lang.spanish_episode_title_label : lang.custom_episode_title_2_label}</label>
                            <input name="CustomEpisodeTitle2" type="text" className="form-control form-control-sm" value={dataItem?.CustomEpisodeTitle?.Title2} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                          </div>
                        </div>}

                        {/* Description */}
                        <div className='row' style={{ marginBottom: '8px' }}>
                          <div className='col-6'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '3px' }}>
                              <label style={{ fontSize: '11px', fontWeight: 600, color: '#444', margin: 0 }}>{lang.description_label}</label>
                              <i className="fa-solid fa-language cursor-pointer" aria-hidden="true" onClick={() => setShowTranslateForm(true)} style={{ color: '#888', fontSize: '14px' }}></i>
                            </div>
                            <textarea
                              rows={2}
                              type="text"
                              className="form-control form-control-sm"
                              name="Description"
                              value={dataItem.Description}
                              onChange={(e) => onChange(e)}
                              required
                              style={{ borderRadius: '4px', border: '1px solid #d0d0d0', resize: 'vertical' }}
                            />
                          </div>
                          <div className='col-6'>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '3px' }}>
                              <label style={{ fontSize: '11px', fontWeight: 600, color: '#444', margin: 0 }}>{lang.custom_description_label}</label>
                              {/* <i className="fa-solid fa-language cursor-pointer" aria-hidden="true" onClick={() => setShowTranslateForm(true)} style={{ color: '#888', fontSize: '14px' }}></i> */}
                            </div>
                            <textarea
                              rows={2}
                              type="text"
                              className="form-control form-control-sm"
                              name="CustomDescription"
                              value={dataItem.CustomDescription}
                              onChange={(e) => onChange(e)}
                              required
                              style={{ borderRadius: '4px', border: '1px solid #d0d0d0', resize: 'vertical' }}
                            />
                          </div>
                        </div>
                        <div className='row' style={{ marginBottom: '8px' }}>
                          <div className="col-6">
                            <label style={style.labelStyel}>{lang.short_title_label}</label>
                            <input name="ShortTitle" type="text" className="form-control form-control-sm" value={dataItem?.ShortTitle} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                          </div>
                          <div className="col-6">
                            <label style={style.labelStyel}>{lang.custom_short_title_label}</label>
                            <input name="CustomShortTitle" type="text" className="form-control form-control-sm" value={dataItem?.CustomShortTitle} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                          </div>
                        </div>

                      </div>

                      {/* ─── Section 2: Content & Identification ─── */}
                      <div style={{ marginBottom: '16px', padding: '12px 14px', background: '#fafafa', borderRadius: '6px', border: '1px solid #f0f0f0' }}>
                        <div style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#3A3633', marginBottom: '10px', paddingLeft: '8px', borderLeft: '3px solid #3A3633' }}>
                          {lang.content_and_identification_section_header}
                        </div>

                        <div className="row">
                          <div className="col-3">
                            <label style={{ fontSize: '11px', fontWeight: 600, color: '#444', marginBottom: '3px', display: 'inline-block' }}>{lang.content_label} *</label>
                            <InfoRoundButton message={lang.used_to_configure_prefix_suffix_and_incremental_next_number_for_assetid_tooltip}></InfoRoundButton>
                            <div style={{ display: 'flex', gap: '3px' }}>
                              <DropDownList
                                data={content}
                                name="Content"
                                textField="Description"
                                dataItemKey="_id"
                                value={dataItem.Content}
                                onChange={onChange}
                                disabled={dataItem.SID > 0 ? true : false}
                              />
                              <button type="button" title={lang.create_content_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                                style={{ height: "28px", minWidth: '28px', padding: '0 5px', flexShrink: 0 }} onClick={() => { onCreateMasterClick('Content') }}><i className="fa-solid fa-plus fa-xs"></i>
                              </button>
                            </div>
                          </div>

                          <div className='col-3'>
                            <label style={style.labelStyel}>{lang.provider_label}</label>
                            <DropDownList
                              data={providers}
                              name="Provider"
                              textField="Description"
                              dataItemKey="_id"
                              value={dataItem.Provider}
                              onChange={onChange}
                            />
                          </div>

                          <div className='col-3'>
                            <label style={style.labelStyel}>{lang.reference_code_label}{company && company?.segByRc ? " *" : ""}</label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              name="ReferenceCode"
                              value={dataItem.ReferenceCode}
                              onChange={(e) => onChange(e)}
                              style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }}
                            />
                          </div>

                          <div className="col-3">
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: '3px' }}>
                              <label style={{ fontSize: '11px', fontWeight: 600, color: '#444', margin: 0 }}>
                                {lang.asset_id_label}
                              </label>
                              {dataItem.SID == 0 && <div style={{ display: "flex", alignItems: "center", gap: '2px' }}>
                                <Field
                                  name="isManualAssetId"
                                  component={Checkbox}
                                  onChange={async (e) => {
                                    if (!e.target.value) {
                                      setDataItem({
                                        ...dataItem,
                                        AssetId: await DataHelper.getNewAssetId(dataItem.Content),
                                      });
                                    }
                                    props.setIsManualAssetId(e.target.value);
                                  }}
                                  checked={props.isManualAssetId}
                                  style={{ marginRight: "2px", borderColor: "black" }}
                                />
                                <label
                                  htmlFor="isManualAssetId"
                                  style={{ fontSize: "10px", margin: 0, cursor: "pointer", color: '#777' }}
                                >
                                  {lang.manual_label}
                                </label>
                              </div>}
                            </div>
                            {dataItem.SID > 0 || props.isManualAssetId ? (
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                name="AssetId"
                                value={dataItem.AssetId}
                                onChange={(e) => onChange(e)}
                                style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }}
                              />
                            ) : (
                              <div style={{ fontSize: '13px', fontWeight: 600, color: '#333', padding: '4px 0' }}>{dataItem.AssetId}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div> {/* Close Left Panel */}

                    {/* ── Right Panel: Image Preview ── */}
                    <div style={{ width: '200px', flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div style={{ background: '#fafafa', borderRadius: '8px', border: '1px solid #f0f0f0', padding: '12px', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                        <div style={{ display: 'flex', gap: '6px', marginBottom: '8px', alignItems: 'center' }}>
                          <i className="fa fa-pencil" title="Edit Image Url" style={{ cursor: 'pointer', fontSize: '13px', color: '#666', padding: '5px', borderRadius: '4px', background: '#eee', transition: 'background 0.2s' }} onClick={() => setOpenImageInput(true)}></i>
                          <i className="fa fa-file-text" title="Select Image" style={{ cursor: 'pointer', fontSize: '13px', color: '#666', padding: '5px', borderRadius: '4px', background: '#eee' }} onClick={() => setOpenImageBank(true)}></i>
                          <i className="fa fa-magnifying-glass" title="Browse Image" style={{ cursor: 'pointer', fontSize: '13px', color: '#666', padding: '5px', borderRadius: '4px', background: '#eee' }} onClick={() => setOpenImageBrowse(true)}></i>
                          <BossAssistantIcon
                            style={{}}
                            mediaEpisodeEntity={dataItem}
                            iconSize={"22px"}
                            onDataLoad={onBossAIMetaDataLoad}
                            popupTtle={"Generate Thumbnail with Boss AI"}
                            tooltip={"Generate Thumbnail with Boss AI"}
                            description={"BOSS AI Generating Thumbnail"}
                            setMetaData={setImageUrl}
                          />
                        </div>
                        <div style={{ width: '176px', height: '246px', overflow: 'hidden', borderRadius: '6px', boxShadow: '0 1px 8px rgba(0,0,0,0.12)', background: '#fff' }}>
                          <ImageCard style={{ width: '100%', height: '100%', objectFit: 'cover' }} width={"100%"} height={"100%"} img={dataItem.ImageUrl} alt='Dummy' />
                        </div>
                      </div>
                    </div>
                  </div> {/* Close Flex container */}

                  {/* ─── Section 3: Timing & Classification ─── */}
                  <div style={{ marginBottom: '16px', padding: '12px 14px', background: '#fafafa', borderRadius: '6px', border: '1px solid #f0f0f0' }}>
                    <div style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#3A3633', marginBottom: '10px', paddingLeft: '8px', borderLeft: '3px solid #3A3633' }}>
                      {lang.timing_and_classification_section_header}
                    </div>

                    <div className="row">
                      <div className="col-3">
                        <label style={style.labelStyel}>{lang.duration_label} *</label>
                        <TimePickerWithFormat
                          className="form-control form-control-sm"
                          name="DurationString"
                          value={durationString}
                          onChange={(e) => onChange(e)}
                          required
                        />
                      </div>
                      <div className="col-3">
                        <label style={style.labelStyel}>{lang.transmission_label}</label>
                        <DropDownList
                          style={{ backgroundColor: "white" }}
                          data={transmissions}
                          textField='Description'
                          dataItemKey='_id'
                          className="form-control form-control-sm"
                          name="Transmission"
                          value={dataItem.Transmission}
                          onChange={(e) => onChange(e)}
                        />
                      </div>
                      <div className="col-3">
                        <label style={style.labelStyel}>{`${lang.media_type_label}${dataItem?.Content?.Custom === CONTENT_CUSTOM_ENUM.ECITY_LC_Y_TSN_CNC_PC_EP ? " *" : ''}`}</label>
                        <DropDownList
                          data={genre}
                          name={"MediaType"}
                          textField="Description"
                          dataItemKey="_id"
                          value={dataItem.MediaType}
                          onChange={onChange}
                        />
                      </div>
                      <div className="col-3">
                        <label style={style.labelStyel}>{lang.media_sub_type_label}</label>
                        <DropDownList
                          data={genre}
                          name={"MediaSubType"}
                          textField="Description"
                          dataItemKey="_id"
                          value={dataItem.MediaSubType}
                          onChange={onChange}
                        />
                      </div>
                    </div>
                  </div>

                  {/* ─── Section 4: Genre, Categorization & Metadata ─── */}
                  <div style={{ marginBottom: '16px', padding: '12px 14px', background: '#fafafa', borderRadius: '6px', border: '1px solid #f0f0f0' }}>
                    <div style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#3A3633', marginBottom: '10px', paddingLeft: '8px', borderLeft: '3px solid #3A3633' }}>
                      {lang.genre_categorization_and_metadata_section_header}
                    </div>

                    <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                      <div style={{ flex: 1, minWidth: '150px' }}>
                        <label style={style.labelStyel}>{lang.genre_label} *</label>
                        <div style={{ display: 'flex', gap: '3px' }}>
                          <MultiSelect
                            data={genre}
                            name={"Genres"}
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.Genres}
                            onChange={onChange}
                          />
                          <button type="button" title={lang.create_genre_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                            style={{ height: "28px", minWidth: '28px', padding: '0 5px', flexShrink: 0 }} onClick={() => { onCreateMasterClick('Genre') }}><i className="fa-solid fa-plus fa-xs"></i>
                          </button>
                        </div>
                      </div>

                      <div style={{ flex: 1, minWidth: '150px' }}>
                        <label style={style.labelStyel}>{lang.sub_genre_label}</label>
                        <div style={{ display: 'flex', gap: '3px' }}>
                          <MultiSelect
                            data={genre}
                            name={"SubGenres"}
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.SubGenres}
                            onChange={onChange}
                          />
                          <button type="button" title={lang.create_sub_genre_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                            style={{ height: "28px", minWidth: '28px', padding: '0 5px', flexShrink: 0 }} onClick={() => { onCreateMasterClick('Genre') }}><i className="fa-solid fa-plus fa-xs"></i>
                          </button>
                        </div>
                      </div>

                      {/* <div style={{ flex: 1, minWidth: '150px' }}>
                        <label style={style.labelStyel}>{lang.target_group_label}</label>
                        <DropDownList
                          style={{ backgroundColor: "white" }}
                          data={targetGroups}
                          textField='Name'
                          dataItemKey='_id'
                          className="form-control form-control-sm"
                          name="TargetGroup"
                          value={dataItem.TargetGroup}
                          onChange={(e) => onChange(e)}
                        />
                      </div> */}

                      <div style={{ flex: 1, minWidth: '150px' }}>
                        <label style={style.labelStyel}>
                          {dataItem?.Content?.Custom === CONTENT_CUSTOM_ENUM.ECITY_LC_Y_TSN_CNC_PC_EP
                            ? `${lang.country_label} *`
                            : `${lang.languages_label} ${dataItem?.Content?.Custom === CONTENT_CUSTOM_ENUM.ETISALAT_TIT_Y_SN_EP_LNG ? "*" : ""}`
                          }
                        </label>
                        <div style={{ display: 'flex', gap: '3px' }}>
                          {dataItem?.Content?.Custom === CONTENT_CUSTOM_ENUM.ECITY_LC_Y_TSN_CNC_PC_EP ? (
                            <DropDownList
                              data={countries}
                              name="Country"
                              textField="Description"
                              dataItemKey="_id"
                              value={props?.metaData?.Country}
                              onChange={onChange}
                            />
                          ) : (
                            <MultiSelect
                              data={languages}
                              name={"Languages"}
                              textField="Description"
                              dataItemKey="_id"
                              value={props?.metaData?.Languages}
                              onChange={onChange}
                            />
                          )}
                        </div>
                      </div>
                      <div style={{ flex: 1, minWidth: '150px' }}>
                        <label style={style.labelStyel}>{lang.dubbed_languages_label}</label>
                        <MultiSelect
                          data={languages}
                          name={"DubbedLanguages"}
                          textField="Description"
                          dataItemKey="_id"
                          value={props?.metaData?.DubbedLanguages}
                          onChange={onChange}
                        />
                      </div>

                    </div>
                    <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }} className='mt-2'>
                      <div style={{ flex: 1, minWidth: '150px' }}>
                        <label style={style.labelStyel}>{lang.pg_rating_label}</label>
                        <DropDownList
                          data={pgRatings}
                          name="PGRating"
                          textField="Description"
                          dataItemKey="_id"
                          value={props?.metaData?.PGRating}
                          onChange={onChange}
                        />
                      </div>
                      <div style={{ flex: 1, minWidth: '150px' }}>
                        <label style={style.labelStyel}>{`${lang.production_year_label} ${dataItem.Content && dataItem.Content.Custom && dataItem.Content.Custom == CONTENT_CUSTOM_ENUM.ETISALAT_TIT_Y_SN_EP_LNG ? "*" : ""}`}</label>
                        <input name="ProductionYear" type="text" className="form-control form-control-sm" value={props?.metaData?.ProductionYear} onChange={onChange} style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }} />
                      </div>
                      <div style={{ flex: 1, minWidth: '150px' }}>
                        <label style={style.labelStyel}>{lang.deal_reference_label}</label>
                        <input name="DealReference" type="text" className="form-control form-control-sm" value={dataItem.DealReference} onChange={(e) => onChange(e)} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label style={style.labelStyel}>{lang.working_title_label}</label>
                        <input name="WorkingTitle" type="text" className="form-control form-control-sm" value={dataItem.WorkingTitle} onChange={(e) => onChange(e)} disabled />
                      </div>
                    </div>
                  </div>

                  {/* ─── Section 5: Deal Rights ─── */}
                  {dataItem.SID == 0 && (<div className='row mb-3'>
                    <div className='col-6'>
                      <div style={{ padding: '10px 14px', background: '#fafafa', borderRadius: '6px', border: '1px solid #f0f0f0' }}>
                        <div style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#3A3633', marginBottom: '8px', paddingLeft: '8px', borderLeft: '3px solid #3A3633' }}>{lang.linear_deal_rights_label}</div>
                        <div className='row'>
                          <div className="col-12 mb-2">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                              <label style={style.labelStyel} className="mb-0 fw-semibold"> {lang.linear_channels_label}<span className="text-danger">*</span></label>
                              <div className="d-flex align-items-end">
                                <div>
                                  <input
                                    type="checkbox"
                                    name="isLinearUnlimitedRights"
                                    className="ml-1"
                                    checked={dataItem?.isLinearUnlimitedRights}
                                    onChange={() =>
                                      setDataItem({
                                        ...dataItem,
                                        isLinearUnlimitedRights: !dataItem?.isLinearUnlimitedRights
                                      })
                                    }
                                  />
                                  <span className="ml-1">{lang.is_unlimited_label}</span>
                                </div>
                                <div className='ml-1'>
                                  <input
                                    type="checkbox"
                                    name="isAllChannels"
                                    className="ml-1"
                                    value={selectAllChannels}
                                    checked={selectAllChannels}
                                    onChange={onChange}
                                  />
                                  <span className="ml-1">{lang.select_all_label}</span>
                                </div>
                              </div>
                            </div>
                            <MyMultiSelect
                              data={channels}
                              name="Channels"
                              textField="FullChannelName"
                              dataItemKey="_id"
                              value={dataItem.Channels}
                              onChange={onChange}
                            />
                          </div>
                          {!dataItem?.isLinearUnlimitedRights ? <>
                            <div className="col-6">
                              <label style={style.labelStyel}>{lang.start_date_label} *</label>
                              <input
                                type="datetime-local"
                                className="form-control form-control-sm"
                                name="LinearStartDate"
                                value={dataItem.LinearStartDate}
                                onChange={onChange}
                              />
                            </div>
                            <div className="col-6">
                              <label style={style.labelStyel}>{lang.end_Date_label} *</label>
                              <input
                                type="datetime-local"
                                className="form-control form-control-sm"
                                name="LinearEndDate"
                                value={dataItem.LinearEndDate}
                                onChange={onChange}
                              />
                            </div>
                          </> :
                            <div className="col-12 mt-1">
                              <small className="text-muted" style={{ fontSize: "11px" }}>
                                Note: Linear Deal Rights validity will default from{" "}
                                <strong>{moment.utc().startOf('day').format('DD/MM/YYYY')}</strong>
                                {" "}to{" "}
                                <strong>{moment.utc().add(50, 'year').endOf('day').format('DD/MM/YYYY')}</strong>
                                {" "}when Unlimited is enabled.
                              </small>
                            </div>}
                        </div>
                      </div>
                    </div>

                    <div className='col-6'>
                      <div style={{ padding: '10px 14px', background: '#fafafa', borderRadius: '6px', border: '1px solid #f0f0f0' }}>
                        <div style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#3A3633', marginBottom: '8px', paddingLeft: '8px', borderLeft: '3px solid #3A3633' }}>{lang.non_linear_deal_rights_label}</div>
                        <div className='row'>
                          <div className="col-12 mb-2">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                              <label style={style.labelStyel} className="mb-0 fw-semibold"> {lang.non_linear_platforms_label}</label>
                              <div className="d-flex align-items-end">
                                <div>
                                  <input
                                    type="checkbox"
                                    name="isNonLinearUnlimitedRights"
                                    className="ml-1"
                                    checked={dataItem?.isNonLinearUnlimitedRights}
                                    onChange={() =>
                                      setDataItem({
                                        ...dataItem,
                                        isNonLinearUnlimitedRights: !dataItem?.isNonLinearUnlimitedRights
                                      })
                                    }
                                  />
                                  <span className="ml-1">{lang.is_unlimited_label}</span>
                                </div>
                                <div className='ml-1'>
                                  <input
                                    type="checkbox"
                                    name="isAllPlatforms"
                                    className="ml-1"
                                    value={selectAllPlatforms}
                                    checked={selectAllPlatforms}
                                    onChange={onChange}
                                  />
                                  <span className="ml-1">{lang.select_all_label}</span>
                                </div>
                              </div>
                            </div>
                            <MyMultiSelect
                              data={platforms}
                              name="Platforms"
                              textField="Description"
                              dataItemKey="_id"
                              value={dataItem.Platforms}
                              onChange={onChange}
                            />
                          </div>
                          {!dataItem?.isNonLinearUnlimitedRights ? <>
                            <div className="col-6">
                              <label style={style.labelStyel}>{lang.start_date_label} *</label>
                              <input
                                type="datetime-local"
                                className="form-control form-control-sm"
                                name="NonLinearStartDate"
                                value={dataItem.NonLinearStartDate}
                                onChange={onChange}
                              />
                            </div>
                            <div className="col-6">
                              <label style={style.labelStyel}>{lang.end_Date_label} *</label>
                              <input
                                type="datetime-local"
                                className="form-control form-control-sm"
                                name="NonLinearEndDate"
                                value={dataItem.NonLinearEndDate}
                                onChange={onChange}
                              />
                            </div>
                          </> :
                            <div className="col-12 mt-1">
                              <small className="text-muted" style={{ fontSize: "11px" }}>
                                Note: Non Linear Deal Rights validity will default from{" "}
                                <strong>{moment.utc().startOf('day').format('DD/MM/YYYY')}</strong>
                                {" "}to{" "}
                                <strong>{moment.utc().add(50, 'year').endOf('day').format('DD/MM/YYYY')}</strong>
                                {" "}when Unlimited is enabled.
                              </small>
                            </div>}
                        </div>
                      </div>
                    </div>
                  </div>)}

                  {/* ─── Section 6: Options ─── */}
                  <div style={{ padding: '10px 14px', background: '#fafafa', borderRadius: '6px', border: '1px solid #f0f0f0' }}>
                    <div style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#3A3633', marginBottom: '8px', paddingLeft: '8px', borderLeft: '3px solid #3A3633' }}>
                      {lang.options_label}
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '18px', flexWrap: 'wrap' }}>
                      <Field
                        style={{ borderColor: "black" }}
                        name={"Archive"}
                        component={Checkbox}
                        label={lang.archive}
                        onChange={(e) => onChange(e)}
                        checked={dataItem.Archive ? true : false}
                      />

                      {selectedMediaCategorySID == MEDIACATEGORIES.Program &&
                        <Field
                          style={{ borderColor: "black" }}
                          name={"IsLive"}
                          component={Checkbox}
                          label={lang.islive_label}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.IsLive ? true : false}
                        />
                      }

                      {selectedMediaCategorySID == MEDIACATEGORIES.Program && dataItem.IsLive &&
                        <Field
                          style={{ borderColor: "black" }}
                          name={"AlwaysLive"}
                          component={Checkbox}
                          label={lang.alwaysLive_label}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.AlwaysLive ? true : false}
                        />
                      }

                      {selectedMediaCategorySID == MEDIACATEGORIES.Program &&
                        <Field
                          style={{ borderColor: "black" }}
                          name={"IsMusic"}
                          component={Checkbox}
                          label={lang.is_music_label}
                          onChange={(e) => onChange(e)}
                          checked={dataItem.IsMusic}
                          value={dataItem.IsMusic}
                        />
                      }
                    </div>

                    {dataItem.IsMusic &&
                      <div className="row" style={{ marginTop: '10px' }}>
                        <div className="col-6">
                          <label style={style.labelStyel}>{lang.music_category_label}</label>
                          <div style={{ display: 'flex', gap: '3px', alignItems: 'center' }}>
                            <input
                              name={"MusicCategory"}
                              className="form-control form-control-sm"
                              type={'text'}
                              value={selectedMusicCategory.Name}
                              disabled={true}
                              style={{ borderRadius: '4px', border: '1px solid #d0d0d0' }}
                            />
                            <button type="button" title='Select Music category' className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                              style={{ height: "28px", minWidth: '28px', padding: '0 5px', flexShrink: 0 }} onClick={() => setOpenMusicCategory(true)}><i className="fa-solid fa-ellipsis-h fa-xs"></i>
                            </button>
                            <button type="button" title='Available Music' className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-warning"
                              style={{ height: "28px", minWidth: '28px', padding: '0 5px', flexShrink: 0 }} onClick={handleMusicPreview}><i className="fa-solid fa-eye fa-xs"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    }
                  </div>

                </FormElement>
              )}
            />

            {/* Footer Note */}
            {dataItem.SID == 0 && <p className='text-muted' style={{ fontSize: '10px', marginTop: '12px', marginBottom: 0, color: '#999' }}>{`* ${currentUserChannels && currentUserChannels.length == 1 ? `Deal Rights will automatically be created for ${currentUserChannels[0].FullChannelName}` : "Please create deal rights before saving"}`}</p>}
          </BossDialog>
        </>}

      {openImageBank && <CollectionSelection entityname={ENTITYNAME.OttPosters} closeForm={() => setOpenImageBank(false)} setDataList={setSelectedImage} title={lang.select_image_collection_header} mode={"single"} width={"50vw"} />}

      {/* Image Content Popup */}
      {openImageInput && <MMImageEditForm onClose={() => setOpenImageInput(false)} selectedImageUrl={dataItem.ImageUrl} setDataList={(img) => { setSelectedImageUrl(img); setDataItem({ ...dataItem, ["ImageUrl"]: img }) }} />}
      {openImageBrowse && <MMImageEditForm onClose={() => setOpenImageBrowse(false)} isBrowse={true} selectedImageUrl={dataItem.ImageUrl} setDataList={(img) => { setSelectedImageUrl(img); setDataItem({ ...dataItem, ["ImageUrl"]: img }) }} />}

      {showEditForm.Content && <ContentEditForm item={{ SID: 0 }} cancelEdit={() => setShowEditForm(false)} refresh={() => loadCombo(false)} filterMediaCategory={props.mediaCategory} />}
      {showEditForm.Genre && <GenreEditForm item={{ SID: 0 }} cancelEdit={() => setShowEditForm(false)} refresh={() => loadCombo(false)} />}
      {showTranslateForm && <LanguageTranslator onSubmit={handleLangugaeTranslate} cancelEdit={() => setShowTranslateForm(false)} />}
      {showIMDbForm && <IMDBEditForm mediaCategory={props.mediaCategory} cancelEdit={() => setShowIMDbForm(false)} imdbDataList={handleIMDbDataList} />}
      {openMusicCategory && <CollectionSelection addButtonTitle={lang.select_button_text} entityname={ENTITYNAME.MusicCategory} closeForm={() => setOpenMusicCategory(false)} setDataList={(data) => setSelectedMusicCategory(data[0])} title={lang.select_music_category_dialog_header} mode={"single"} width={"50vw"} />}
      {
        showAvailableMusic &&
        <BossDialog title={lang.available_music_dialog_header} onClose={() => { setShowAvailableMusic(false); setIsLoading(true); }} width={"50vw"}>
          {isLoading && <Loader height="40vh" />}
          {!isLoading && <Grid data={musicData} style={{ height: "400px" }} rowHeight={50} resizable={true}>
            <GridColumn field={'Title'} title={'Title'} />
            <GridColumn field={'MediaCategory.Description'} title={'Media Category'} />
            <GridColumn field={'AssetId'} title={'Asset Id'} />
            <GridColumn field={'Genres'} title={'Genres'} cell={ArrayCell} format="Description" />
            <GridColumn field={'Duration'} title={'Duration'} cell={TimeCell} sortable={true} />
          </Grid>}
        </BossDialog>
      }
      {openMediaEpisodeSettingForm && <MediaEpisodeSettingForm onCancel={() => setOpenMediaEpisodeSettingForm(false)} data={dataItem} entityName={ENTITYNAME.MediaEpisode} setData={setDataItem} />}
    </div >
  )
}
